import React, { useState, useEffect } from "react";

import EditContainer from "../components/EditContainer";
import EntryCareer from "../components/EntryCareer";
import ViewCareer from "../components/ViewCareer";
import { useUser } from "../firebase";

const initialValue = {
  jobField: "",
  employer: "",
  jobTitle: "",
  country: "",
  state: "",
  from: "",
  to: ""
};

const EditCareer = ({ location }) => {
  const { profile, updateProfile } = useUser();
  const [editing, setEditing] = useState(-1);
  useEffect(
    () => {
      if (profile && (!profile.career || profile.career.length === 0)) {
        setEditing(-2);
      }
    },
    [profile]
  );

  const career = (profile && profile.career) || [];
  const setCareer = async value => {
    await updateProfile({ career: value });
  };

  const handleAdd = async (values, actions) => {
    await setCareer([...career, values]);
    actions.setSubmitting(false);
    setEditing(-1);
  };

  const handleDelete = async idx => {
    const newCareer = [...career];
    newCareer.splice(idx, 1);
    await setCareer(newCareer);
    setEditing(-1);
  };

  return (
    <EditContainer
      title="Career"
      handleAdd={() => setEditing(-2)}
      addDisabled={editing !== -1}
    >
      <div>
        {editing === -2 && (
          <EntryCareer
            values={initialValue}
            onSubmit={handleAdd}
            onCancel={() => setEditing(-1)}
            noDelete
          />
        )}
        {career.map((edu, idx) => {
          if (editing === idx) {
            const handleSubmit = async (values, actions) => {
              const newCareer = [...career];
              newCareer[idx] = values;
              await setCareer(newCareer);
              actions.setSubmitting(false);
              setEditing(-1);
            };
            return (
              <EntryCareer
                key={idx}
                values={edu}
                onSubmit={handleSubmit}
                onDelete={() => handleDelete(idx)}
                onCancel={() => setEditing(-1)}
              />
            );
          } else {
            return (
              <ViewCareer
                key={idx}
                values={edu}
                onEdit={() => setEditing(idx)}
                editing={editing !== -1}
              />
            );
          }
        })}
      </div>
    </EditContainer>
  );
};

export default EditCareer;
